import { TicketUiModel } from '../model/ui/ticket.ui.model';

export class ReportConverter {
  static toDbo(source: TicketUiModel): any {
    return {
      attributes: {
        description: [
          source.description
        ],
        solution: [
          source.solution
        ],
        transportMode: [
          source.transport
        ],
        geometry: source.geometry,
        category: [
          source.category
        ],
        image: source.image
      }
    }
  }

  static toDboForUpdate(source: TicketUiModel): any {
    return {
      description: [
        source.description
      ],
      solution: [
        source.solution
      ],
      transportMode: [
        source.transport
      ],
      category: [
        source.category
      ],
      status: [
        source.status
      ],
      weeks_visible: [
        source.weeks_visible
      ],
      advice: [
        source.advice
      ],
      image: source.image,
      geometry: source.geometry,
      address: [source.address],
    }
  }


  static toUiMReport(source: any): any {
    const attrs = source.genericAttributes.attributes;
    return {
      id: source.entityID.id2,
      projectId: source.entityID.id1.id,
      date: source.timeStamp,
      lastUpdated: source.lastUpdated,
      category: attrs.category && attrs.category.length ? attrs.category[0] : '',
      description: attrs.description && attrs.description.length ? attrs.description[0] : '',
      source: attrs.source_device && attrs.source_device.length ? attrs.source_device[0] : '',
      address: attrs.address && attrs.address.length ? attrs.address[0] : '',
    }
  }
}
